import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CouponResponse, EstimateResponse, EstimationRequest } from '../models/payment.model';

@Injectable()
export class PaymentService {

  constructor(private http: HttpClient) {}

  getEstimate(companyId: string, data: EstimationRequest): Observable<EstimateResponse> {
    return this.http.post<EstimateResponse>(
      `${environment.apiEndpoint}/api/v1/store/${companyId}/estimate`,
      data
    );
  }

  getCouponInfo(id: string, chargebeeAccount: string): Observable<CouponResponse> {
    return this.http.get<CouponResponse>(
      `${environment.apiEndpoint}/api/v1/coupons/${id}?chargebee_account=${chargebeeAccount}`
    );
  }
}